// extracted by mini-css-extract-plugin
module.exports =  {"container":"U4YUY7OaXOqQN2i6VgdH","animations":"Waip1DIZEhT6mh86hUQ8","vertical":"rIQVFellwhWck6pRjYuv","logo":"AJYYAAOrVn8FKpNk4_ew"};